import React from "react"
import { EcommerceWrapper } from "./Ecommerce.styles"
import { Col, Container, Row } from "react-bootstrap"

const Ecommerce = ({ description, dataTitles, dataValues }) => {

return (
<EcommerceWrapper className="py-3 py-sm-5 px-4 px-sm-5 ">
  <Container className="py-5">
    <Row>
      <Col lg={8} className="text-left pr-lg-3 px-0 pb-5 pb-lg-3 pl-lg-0">
      <h2 className="h1 font-weight-bold secondary-blue-2-text mb-4 nunito">
        E-commerce
      </h2>
      <p>
        { description }
      </p>
      </Col>
      <Col lg={4} className="my-auto text-right pl-lg-3 px-0">
        <div className="dataContainer text-center">
          {
            dataTitles.map((dataTitle, i) => {
              if(dataTitle && dataValues[i]) {
                const addClasses = i % 2 === 0
                  ? "float-sm-left px-0 pl-sm-4 pr-sm-2 px-lg-0"
                  : "float-sm-right px-0 pr-sm-4 pl-sm-2 px-lg-0"
                return <div className={"dataPoint mb-4 pb-2 d-sm-inline-block " + addClasses}>
                  <div class="dataValue">{dataValues[i]}</div>
                  <div class="dataTitle">{dataTitle}</div>
                </div>
              }
              else{
                return '';
              }
            })
          }
        </div>
      </Col>
    </Row>
  </Container>
</EcommerceWrapper>
)
}

export default Ecommerce
